import { api } from "@/boot/axios";
import type { Application } from "@/interfaces";

export function useApplication() {

  const sendApplication = async (applicationData: Application) => {
    try {
      const response = await api.post('application/send', applicationData)
      return response.status
    } catch (er: any) {
      console.error('Error:', er)
      return er.response.status
    }
  }

  const checkApplication = async (telegramId: number) => {
    try {
      const response = await api.get('application/check', {
        params: { telegramId }
      });
      return response
    } catch (er: any) {
      console.error(er)
      return er.response.status
    }
  }

  return {
    sendApplication,
    checkApplication
  }
}